import React from 'react';
import { CheckCircle2Icon, GiftIcon, LockIcon, ShieldCheckIcon } from 'lucide-react';
import { Countdown } from './Countdown';
import { CTAButton } from './CTAButton';
import { PRODUCT_IMAGE, BONUSES } from '../lib/data';
const INCLUDED = ['6 Tomos completos · 360 páginas', 'Planillas y calculadoras en Excel', 'Contenido específico para porteras', 'Acceso inmediato · 100% PDF'];
export function Checkout() {
  return <section id="checkout" className="scroll-mt-4 px-4 py-8" data-id="element-44" data-mp="39qtnbh2e4041">
      <div className="overflow-hidden rounded-3xl border border-hockey-pink/45 bg-hockey-card shadow-2xl" data-id="element-45" data-mp="34pw7hb4uri5p">
        <div className="border-b border-white/10 bg-hockey-greendark/50 px-5 py-5 text-center" data-id="element-46" data-mp="2zqaz6a3slxgb">
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-hockey-pink" data-id="element-47" data-mp="2vq96gqg1ced6">Oferta de hoy</p>
          <h2 className="mt-1 font-display text-3xl leading-none text-white" data-id="element-48" data-mp="xyoc2jn0ump4">Hockey Pro System</h2>
          <p className="mt-2 text-sm text-white/65" data-id="element-49" data-mp="tz5sbr6xshnv">Tu sistema completo para rendir al máximo.</p>
        </div>

        <div className="space-y-5 p-5" data-id="element-50" data-mp="2ebi5x6jpos7h">
          <Countdown data-id="element-51" data-mp="2eemcgakng01b" />

          <div className="flex items-center gap-3" data-id="element-52" data-mp="2jbw1hp44m9om">
            <img src={PRODUCT_IMAGE} alt="Hockey Pro System" className="h-20 w-20 shrink-0 rounded-xl object-cover" data-id="element-53" data-mp="2jcnz15haahhj" />
            <div className="min-w-0" data-id="element-54" data-mp="29dye13u3cgx2">
              <p className="text-base font-extrabold text-white" data-id="element-55" data-mp="29f02ca04azwq">Todo lo que necesitas, en un solo lugar</p>
              <p className="mt-1 text-[13px] leading-snug text-white/60" data-id="element-56" data-mp="2x53vtojldja0">
                Método, planificación y recursos listos para usar desde tu próximo entrenamiento.
              </p>
            </div>
          </div>

          <ul className="space-y-2 border-y border-white/10 py-4 text-[13px]" data-id="element-57" data-mp="2sbj2wawuvfho">
            {INCLUDED.map(item => <li key={item} className="flex items-center gap-2 text-white/85" data-id="element-58" data-mp="3g0kg0bgmveta">
                <CheckCircle2Icon className="h-4 w-4 shrink-0 text-emerald-400" data-id="element-59" data-mp="3ksvjfoal1iql" />
                {item}
              </li>)}
          </ul>

          <div data-id="element-60" data-mp="3unj3xwga7r39">
            <p className="flex items-center gap-2 text-sm font-extrabold text-hockey-pink" data-id="element-61" data-mp="3ulzp8aa9xo3l">
              <GiftIcon className="h-5 w-5" data-id="element-62" data-mp="3qkw9row51u2w" /> Además, 9 bonos GRATIS solo hoy
            </p>
            <div className="mt-3 grid grid-cols-1 gap-1.5" data-id="element-63" data-mp="3lpqo8r6nehfc">
              {BONUSES.map(bonus => <p key={bonus.title} className="flex items-center gap-2 text-[12px] text-white/75" data-id="element-64" data-mp="3gqnn3htsgvcn">
                  <span aria-hidden="true" data-id="element-65" data-mp="3brayarjcxe7f">{bonus.emoji}</span>
                  <span className="flex-1 leading-snug" data-id="element-66" data-mp="36xyb8lubtfgs">{bonus.title}</span>
                  <span className="text-[10px] font-extrabold text-emerald-400" data-id="element-67" data-mp="32wd2ncotrnce">GRATIS</span>
                </p>)}
            </div>
          </div>

          <div className="flex items-end justify-between border-t border-white/10 pt-4" data-id="element-68" data-mp="2xw8kzjc6kmkl">
            <div data-id="element-69" data-mp="2t12xig34qzue">
              <p className="text-xs font-medium text-white/50" data-id="element-70" data-mp="2nzvq4i4wg2o9">Pago único · Acceso inmediato</p>
              <div className="mt-1 flex items-baseline gap-2" data-id="element-71" data-mp="2dvywhho3rw4a">
                <span className="text-lg font-semibold text-white/40 line-through" data-id="element-72" data-mp="2dvfanpvc0nkz">€50</span>
                <span className="font-display text-5xl leading-none text-hockey-pink" data-id="element-73" data-mp="2itguid0l0qxi">€20</span>
              </div>
            </div>
            <span className="rounded-full bg-emerald-500/15 px-2.5 py-1.5 text-[11px] font-bold text-emerald-400" data-id="element-74" data-mp="2nsabiff2v02f">
              Ahorras €30
            </span>
          </div>

          <CTAButton label="Quiero dominar los partidos" data-id="element-75" data-mp="1v7adx2d3e2vo" />

          <div className="flex items-center justify-center gap-4 text-[11px] text-white/50" data-id="element-76" data-mp="203r2fxo7ej9a">
            <span className="flex items-center gap-1" data-id="element-77" data-mp="2533mybrlre8p">
              <LockIcon className="h-3.5 w-3.5" data-id="element-78" data-mp="251k7uohon98i" /> Pago seguro
            </span>
            <span className="flex items-center gap-1" data-id="element-79" data-mp="29vwq4v7faeio">
              <ShieldCheckIcon className="h-3.5 w-3.5" data-id="element-80" data-mp="1cfhk55q78dmw" /> Recíbelo al instante
            </span>
          </div>
        </div>
      </div>
    </section>;
}